import { AxiosInstance } from 'axios'
import { Result } from '../../../Shared/Protocol/protocol-result'

export interface TAuthLoginDTO {
  username: string
  password: string
}
export interface TAuthLoginResponse {
  sessionToken: string
  refreshToken: string
  username: string
  permissions: string[]
  permissionsScreens: string[]
  resetPassword: boolean
}

export interface TAuthRefreshTokenResponse {
  token: string
  refreshToken: string
}

export interface TPasswordResetRequestDTO {
  username: string
}

export interface TPasswordResetConfirmDTO {
  token: string
  newPassword: string
}

export interface TPasswordResetMessageResponse {
  message: string
}

export interface TPasswordResetValidateResponse {
  valid: boolean
  message?: string
}

export class AuthenticationApiRemoteService {
  constructor (private readonly service: AxiosInstance) {}

  public login = async (
    data: TAuthLoginDTO
  ): Promise<Result<TAuthLoginResponse>> => {
    try {
      const result = await this.service.post('/login', data)

      return Result.ok(result.data)
    } catch (error: any) {
      throw error?.response?.data
    }
  }

  public refreshToken = async (
    refreshToken: string
  ): Promise<Result<TAuthRefreshTokenResponse>> => {
    try {
      const result = await this.service.post('/refresh-token', { refreshToken })

      return Result.ok(result.data)
    } catch (error: any) {
      throw error?.response?.data
    }
  }

  public requestPasswordReset = async (
    data: TPasswordResetRequestDTO
  ): Promise<Result<TPasswordResetMessageResponse>> => {
    try {
      const result = await this.service.post('/auth/password-reset/request', data)
      return Result.ok(result.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public confirmPasswordReset = async (
    data: TPasswordResetConfirmDTO
  ): Promise<Result<TPasswordResetMessageResponse>> => {
    try {
      const result = await this.service.post('/auth/password-reset/confirm', data)
      return Result.ok(result.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }

  public validatePasswordResetToken = async (
    token: string
  ): Promise<Result<TPasswordResetValidateResponse>> => {
    try {
      const result = await this.service.get('/auth/password-reset/validate', {
        params: { token },
      })
      return Result.ok(result.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }
}
